export default __webpack_public_path__ + "static/0309-b1111e7a3be1e77c757948ec14393743.png";